import request from '@/utils/request'
const api = {
  getProfit: 'profit/getProfit',
  getToDayProfit: 'profit/getToDayProfit',
  getIncomeList: 'profit/getIncomeList'
}
export default {
  getIncomeList(parameter) {
    return request({
      url: api.getIncomeList,
      method: 'post',
      data: parameter
    })
  },
  getProfit(parameter) {
    return request({
      url: api.getProfit,
      method: 'post',
      data: parameter
    })
  },
  getToDayProfit(parameter) {
    return request({
      url: api.getToDayProfit,
      method: 'post',
      data: parameter
    })
  }
}
